module.exports = __webpack_public_path__ + "static/img/专精特新.90bb443.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/专精特新.jpg
// module id = 0WzM
// module chunks = 1